<i class="fas fa-circle" aria-hidden="true" [ngClass]="[statusClass]"></i>
